import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import RateCode, { Campaign, RateCodeSchedule } from '../models/RateCode';
import Urls from './../api/Urls';
import { SupplierUsagePlan } from 'models/Supplier';

export function getRateCodeCampaignList() {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.RATECODE_CAMPAIGN_LIST,
        parser: campaignDataParser,
    }).get();
}

export function createRateCodeCampaign(campaign) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.RATECODE_CAMPAIGN_CREATE
    }).post(campaign);
}

export function getRateCodeListAll(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.RATECODE_LIST_ALL,
        params: params,
        parser: rateCodeAllDataParser,
    }).get();
}

export function getRateCodeListWithPaging(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.RATECODE_LIST_WITH_PAGING,
        params: params,
        parser: rateCodeDataParser,
    }).get();
}

export function getRateCodeList(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.RATECODE_LIST,
        params: params,
        parser: rateCodeDataParser,
    }).get();
}

export function getRateCodeDetail(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.RATECODE_DETAIL,
        endpointParams: { id },
        parser: (data) => new RateCode(data.data),
    }).get();
}

export function createRateCodeDetail(ratecode) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.RATECODE_CREATE,
    }).post(ratecode);
}

export function getRateCodeSchedule(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.RATECODE_SCHEDULE,
        endpointParams: { id },
        parser: (data) => (data?.data || []).map(el=> new RateCodeSchedule(el)),
    }).get();
}

export function getRateCodeInventorydelivery(supplierProductCode) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.RATECODE_INVENTORY,
        params: { supplierProductCode },
    }).post();
}

export function createRateCodeSchedule(rateCodeSchedule) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.RATECODE_SCHEDULE_CREATE,
    }).post(rateCodeSchedule);
}

export function updateRateCodeDetail(rateCode) {
    let id = rateCode.id || null;
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.RATECODE_UPDATE,
        endpointParams: { id },
    }).put(rateCode);
}

export function syncRateCodeSlotServices(id, date) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.RATECODE_SYNC_SLOT_SERVICES,
        endpointParams: { id },
        params: { date },
    }).post();
}

export function lockRateCode(rateCode) {
    let id = rateCode.id || null;
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.RATECODE_LOCK,
        endpointParams: { id },
    }).post();
}

export function deleteAirportDetail(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.RATECODE_DELETE,
        endpointParams: { id }
    }).delete();
}

export function getRateCodeUsagePlanDetail(rateCode) {
    return new ApiService({
      baseURL: Config.API_TOUR,
      endpoint: Urls.GET_RATE_CODE_USAGE_PLAN_WAREHOUSE_GOOD_RECEIPT,
    }).post(rateCode);
  }

export function getStockProducts(data) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.GET_STOCK_PRODUCTS_WAREHOUSE_GOOD_RECEIPT,
    }).post(data);
}

  
export function checkStock(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.ORDER_SURCHARGE_CHECK_STOCK_ACTION,
    }).post(params).catch(err=>err.data);
}

const rateCodeDataParser = (data) => ({
    result: (data.data.result || []).map(item => new RateCode(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
})

const rateCodeAllDataParser = (data) => ({
    result: (data.data || []).map(item => new RateCode(item))
})

const campaignDataParser = (data) => ({
    result: (data.data.result || []).map(item => new Campaign(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
})
